import './RoutesHeader.css';

const RoutesHeader = () => (
  <div className="RoutesHeader">
    <a href="#Me">Me</a>
    <a href="#Games">Games</a>
    <a href="#Websites">Websites</a>
    <a href="#Code">Code</a>
    <a href="#Art">Art</a>
    <a href="#Writings">Writings</a>
    <a href="#Fieldsets">Fieldsets</a>
  </div>
);

export default RoutesHeader;
